'use client';

import React, { useEffect, useRef } from 'react';
import Link from 'next/link';

export default function HeroSection() {
  const heroRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const items = el.querySelectorAll('.hero-reveal');
    items.forEach((item, i) => {
      setTimeout(() => {
        (item as HTMLElement).style.opacity = '1';
        (item as HTMLElement).style.transform = 'translateY(0)';
      }, 100 + i * 120);
    });
  }, []);

  return (
    <section
      ref={heroRef}
      className="pt-32 pb-24 px-6 border-b border-border"
      aria-label="Hero"
    >
      <div className="max-w-container mx-auto">
        {/* Eyebrow */}
        <div
          className="hero-reveal mono-label mb-8"
          style={{ opacity: 0, transform: 'translateY(16px)', transition: 'opacity 0.6s ease, transform 0.6s ease' }}
        >
          Independent Advisory · SAP Analytics Cloud Planning
        </div>

        {/* Main headline */}
        <h1
          className="hero-reveal font-heading font-semibold text-foreground leading-tight mb-6 max-w-4xl"
          style={{
            fontSize: 'clamp(2.75rem, 6vw, 5.5rem)',
            letterSpacing: '-0.03em',
            lineHeight: 1.05,
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          End-to-End SAP Analytics Cloud Planning Advisory
        </h1>

        {/* Subtext */}
        <p
          className="hero-reveal text-lg text-muted max-w-2xl leading-relaxed mb-10 font-body"
          style={{ opacity: 0, transform: 'translateY(16px)', transition: 'opacity 0.6s ease, transform 0.6s ease' }}
        >
          Independent consulting focused on the design, implementation, and
          optimization of SAP Analytics Cloud Planning across enterprise planning
          processes — from financial planning to integrated business planning.
        </p>

        {/* CTAs */}
        <div
          className="hero-reveal flex flex-wrap gap-3 mb-16"
          style={{ opacity: 0, transform: 'translateY(16px)', transition: 'opacity 0.6s ease, transform 0.6s ease' }}
        >
          <Link href="/sac-planning-framework" className="btn-primary">
            Explore the Framework
          </Link>
          <Link href="/knowledge-hub" className="btn-outline">
            Knowledge Hub
          </Link>
          <Link href="/consulting-services" className="btn-outline">
            Consulting Services
          </Link>
        </div>

        {/* Focus areas inline */}
        <div
          className="hero-reveal flex flex-wrap gap-2"
          style={{ opacity: 0, transform: 'translateY(12px)', transition: 'opacity 0.6s ease, transform 0.6s ease' }}
        >
          {[
            'Financial Planning',
            'Operational Planning',
            'Driver-Based Planning',
            'Forecasting',
            'Scenario Planning',
            'Integrated Business Planning',
          ].map((area) => (
            <span key={area} className="tag-pill">
              {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}